<template>
    <div class="w-full h-full flex items-center justify-center">
      <Line :data="chartStat" :options="chartOption" />
    </div>
  </template>
  
  <script>
  import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
      Tooltip,
      Legend
    } from 'chart.js'
    import { Line } from 'vue-chartjs'
    ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  )
  export default {
    components: {
      Line
    },
    data(){
      return{
        year:0,
      }
    },
    mounted(){
      if(this.$store.state.statTransaction[0].length == 0){
        this.year = new Date().getFullYear()
        this.axios.get(this.requestHttp + 'my-stat-transaction/' + this.year, {
          headers: {
              'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
          },
        }).then(({data}) => {
          this.$store.state.statTransaction = data[0]
        })
        .catch()
      }
    },
    computed:{
      requestHttp(){
          return this.$store.state.api
      },
      requestFile(){
          return this.$store.state.apifile
      },
      chartStat(){
          return {
            labels: JSON.parse(this.$i18n.messages[`${localStorage.getItem('langue')}`].mois),
            datasets: [
              {
                label: this.$i18n.messages[`${localStorage.getItem('langue')}`].creditersurlesderniersmois,
                backgroundColor: '#00FF00',
                data: [
                  this.$store.state.statTransaction[0][0],
                  this.$store.state.statTransaction[0][1],
                  this.$store.state.statTransaction[0][2],
                  this.$store.state.statTransaction[0][3],
                  this.$store.state.statTransaction[0][4],
                  this.$store.state.statTransaction[0][5],
                  this.$store.state.statTransaction[0][6],
                  this.$store.state.statTransaction[0][7],
                  this.$store.state.statTransaction[0][8],
                  this.$store.state.statTransaction[0][9],
                  this.$store.state.statTransaction[0][10],
                  this.$store.state.statTransaction[0][11],
                ]
              },
              {
                label: this.$i18n.messages[`${localStorage.getItem('langue')}`].debitersurlesderniersmois,
                backgroundColor: '#f87979',
                data: [
                  this.$store.state.statTransaction[1][0],
                  this.$store.state.statTransaction[1][1],
                  this.$store.state.statTransaction[1][2],
                  this.$store.state.statTransaction[1][3],
                  this.$store.state.statTransaction[1][4],
                  this.$store.state.statTransaction[1][5],
                  this.$store.state.statTransaction[1][6],
                  this.$store.state.statTransaction[1][7],
                  this.$store.state.statTransaction[1][8],
                  this.$store.state.statTransaction[1][9],
                  this.$store.state.statTransaction[1][10],
                  this.$store.state.statTransaction[1][11],
                ]
              }
            ]
          }
        },
        chartOption(){
          return {
            responsive: true,
            maintainAspectRatio: false
          }
        }
    }
  }
  </script>
  
  <style>
  
  </style>